import React from 'react';
import BarcodeScannerComponent from "react-qr-barcode-scanner";

const BarcodeScannerWrapper = ({ onScan }) => {

    const [stopStream, setStopStream] = React.useState(false);

    const handleUpdate = (err, result) => {
        if (result) {
            const mockResult = {
                getText: () => result.text,
            };

            onScan(mockResult);

            setStopStream(true);
        }
    }

    return (
        <div className="scanner-container">
            <BarcodeScannerComponent
                width={400} // You can set a fixed width
                height={400} // and height
                onUpdate={handleUpdate}
                stopStream={stopStream}
                videoConstraints={{ facingMode: 'environment' }}
            />
            <div className="scanner-laser"></div>
            <p style={{ color: '#ccc', fontSize: '0.9rem' }}>Den Barcode mittig im Kamera-Bild positionieren.</p>
        </div>
    );
};

export default BarcodeScannerWrapper;
